import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-money-out-categorize',
  templateUrl: './money-out-categorize.component.html',
  styleUrls: ['./money-out-categorize.component.scss'],
})
export class MoneyOutCategorizeComponent implements OnInit {

  @Input() user: any;
  @Input() isMoneyIn: boolean = false;

  loading: boolean = true;
  step: number = 0;
  initText: string;
  finishText: string;
  initBtnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('bid-create.continue'),
    }
  ];

  constructor(
    private profileService: ProfileService,
    private chdRef: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.initText = !this.isMoneyIn ? this.translate.instant('MOVEMENTS.NO_MONEY_OUT_AVAILABLE_2') : this.translate.instant('MOVEMENTS.NO_MONEY_IN_AVAILABLE');
    this.finishText = !this.isMoneyIn ? this.translate.instant('MOVEMENTS.NO_MONEY_OUT_VALIDATING') : this.translate.instant('MOVEMENTS.NO_MONEY_IN_VALIDATING');
    this.profileService.getProfile(this.user.username).subscribe(resp => {
      if (resp.isEnrolledSca) {
        this.step = 2;
      }
      this.loading = false;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  next() {
    this.step++;
    this.chdRef.detectChanges();
  }
}
